/**
 * Listens on female section clicks and opens URL on home
 *
 * @author Eberhard Lauth
 *
 */

( function ( $ ) {

    $('body.home .female-section, body.home .female-group').click(function() {
        window.open('https://profertil-female.us', '_blank');
    });

} )( jQuery );